// src/components/network/feed/PostList.jsx
import React from 'react';
import PostItem from './PostItem';
import { AlertCircle } from 'lucide-react';

const PostList = ({ 
  posts, 
  loading = false, 
  hasMore = false, 
  onLoadMore, 
  isAuthenticated = false,
  isSavedView = false,
  onUnsave,
  onUpdatePost,
  onDeletePost
}) => {
  
  // Handle updating a post in the posts list
  const handleUpdatePost = (updatedPost) => {
    if (onUpdatePost) {
      onUpdatePost(updatedPost);
    }
  };
  
  if (loading && posts.length === 0) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="animate-spin h-8 w-8 border-4 border-[#190192] rounded-full border-t-transparent"></div>
      </div>
    );
  }
  
  if (!loading && posts.length === 0) {
    return (
      <div className="bg-white rounded-xl shadow-md p-8 text-center">
        <AlertCircle size={48} className="mx-auto text-gray-300 mb-4" />
        <h3 className="text-lg font-medium text-gray-900 mb-2">No posts yet</h3>
        <p className="text-gray-500 max-w-md mx-auto">
          There are no posts to display. Be the first to share something with the network!
        </p>
      </div>
    );
  }
  
  return (
    <div className="space-y-6">
      {posts.map(post => (
        <PostItem 
          key={post.id} 
          post={post} 
          onUpdatePost={handleUpdatePost}
          onDeletePost={onDeletePost}
          onUnsave={onUnsave}
        />
      ))}
      
      {/* Load More Button */}
      {hasMore && (
        <div className="flex justify-center mt-6">
          <button
            onClick={onLoadMore}
            className="px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
            disabled={loading}
          >
            {loading ? (
              <>
                <div className="animate-spin h-4 w-4 border-2 border-[#190192] rounded-full border-t-transparent mr-2"></div>
                Loading...
              </>
            ) : (
              'Load More Posts'
            )}
          </button>
        </div>
      )}
    </div>
  );
};

export default PostList;
